export const img = "assets/img"